import { PageObject, registerRouting, ROUTE_ANCHOR } from "Common/routingUtils";
import Page from "./page";
import hashes from "./routesMap.hash";
import locale from "./routesMap.locale";
import routingKeys from "./routingKeys";
registerRouting(routingKeys.ABOUT, new PageObject(Page, {
    hash: hashes.ABOUT,
    locale: locale.ABOUT
}, null, true, () => `${ROUTE_ANCHOR}${hashes.ABOUT}`));
